import React, { useCallback, useState } from 'react';
import MuroIcon from '@wix/da-ds/pkg/Icons/MuroDraw';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';
import Headerless from '@wix/da-ds/pkg/modals/dsPresets/HeaderlessModal/HeaderlessModal';
const MicroMuro = ({ editor, hideWhenNotEnabled = true })=>{
    var _editor_storage_daextrenderers, _editor_storage;
    const { t } = useTranslation('editor');
    const [showMuroPopup, setShowMuroPopup] = useState(false);
    const hideMuroPopup = useCallback(()=>{
        setShowMuroPopup(false);
    }, [
        setShowMuroPopup
    ]);
    const openMuroModal = useCallback(()=>{
        setShowMuroPopup(true);
    }, [
        setShowMuroPopup
    ]);
    if (!(editor === null || editor === void 0 ? void 0 : (_editor_storage = editor.storage) === null || _editor_storage === void 0 ? void 0 : (_editor_storage_daextrenderers = _editor_storage['da-ext-renderers']) === null || _editor_storage_daextrenderers === void 0 ? void 0 : _editor_storage_daextrenderers.muroMicro)) {
        return null;
    }
    const Micro = editor.storage['da-ext-renderers'].muroMicro;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditorIconButton, {
        tooltipText: t('button.micromuro.tooltip'),
        "aria-label": t('button.micromuro.tooltip'),
        icon: MuroIcon,
        onClick: openMuroModal
    }), showMuroPopup && /*#__PURE__*/ React.createElement(Headerless, {
        useFixedMobileHeight: true,
        isOpen: true,
        hasCloseButton: true,
        onRequestClose: hideMuroPopup
    }, /*#__PURE__*/ React.createElement(Micro, null)));
};
MicroMuro.displayName = 'MicroMuro';
export default MicroMuro;

//# sourceMappingURL=MicroMuro.js.map